import React, { useState, Component,useEffect } from 'react';
import "../assets/css/summary.css";
import { centralCall } from '../api';
import { useParams } from 'react-router-dom';

const Status = () => {
    const { orderGUID } = useParams();
    const [sharedData,setSharedData]=useState(null);
    useEffect(() => {
        // Call PayNow only when the component is mounted
        const payNow = async () => {
            try {
                //const data = await fetchPolicyData(orderGUID);
                //const { Res: Data } = await centralCall({ URL: `/api/Payment/GetPolicyStatus?GUID=${orderGUID}` });
                const data = await centralCall({ URL: `/api/Payment/GetPolicyStatus?GUID=${orderGUID}` });
                setSharedData(data.data.Data);
            } catch (error) {
                console.error('Error fetching Policy data:', error);
            }
        }

        payNow(); // Call the function
    }, []); // Empty dependency array ensures it's called only on mount
    

    return (sharedData &&
        <div className="Summery">
            <div className="container">
                <div className="row">
                    <div className="col-md-9">
                        <div className="owner_detailbox">
                            <h3>Policy Details</h3>
                            <div className="owner_detail">
                                <ul>
                                    <li>
                                        <span>Enquiry Number</span>
                                        <p>{sharedData.EnquiryNo}</p>
                                    </li>
                                    <li>
                                        <span>Policy Status</span>
                                        <p>{sharedData.PolicySuccess == 0 ?"Policy Fail":"Policy Success"}</p>
                                    </li>
                                    <li>
                                        <span>Payment Status</span>
                                        <p>{sharedData.PaymentStatus}</p>
                                    </li>
                                    <li>
                                        <span>Proposal Number</span>
                                        <p>{sharedData.ProposalNo}</p>
                                    </li>
                                    <li>
                                        <span>Premium</span>
                                        <p> ₹ {(sharedData.TotalPremium)}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Status;